module.exports = window.__federationLoadRemote("moduleUa");